function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id", "date", "month", "year", "hasFooter", "hasHeader", "onCancel", "range", "unavailableDates", "onKeyDown", "onMouseEnter", "onMouseLeave", "onSubmit", "onDateChange", "selectRange", "selectWeek", "minDate", "maxDate"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DateUtils from './../../utilities/date-utils/';
import CalendarUtils from './../../utilities/calendar-utils/';
import CalendarDay from './CalendarDay';
import Grid from '../grid';
import Button from '../button/Button';
import Dropdown from '../dropdown';
import Type from '../type';
import generateID from './../../utilities/generateID';
import StyledCalendar from './calendar.styles';
import StyledCalendarBody from './styles/calendar.body.styles';
import StyledCalendarTable from './styles/calendar.table.styles';
import StyledCalendarFooter from './styles/calendar.footer.styles';
import StyledCalendarButtonContainer from './styles/calendar.button-container.styles';
import StyledCalendarTableHeaderDay from './styles/calendar.table-header-day.styles';
import { colors } from '../../styles';
import CONSTANTS from '../../appConstants';
import { DatePickerContext } from '../date-picker/context/date-picker.context';
var calendarPropTypes = {
  /** The selected date. Must be in the form of a JavaScript Date object */
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]))]),
  /** If true, the calendar will be rendered with a footer containing an 'Ok' and 'Cancel' button. */
  hasFooter: PropTypes.bool,
  /** If true, the calendar will be rendered with a header containing navigation controls. */
  hasHeader: PropTypes.bool,
  /** A number (0-11) representing the month that should be rendered. */
  month: PropTypes.number,
  /** @ignore An array containing two date objects that represent a date range to render. */
  range: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  /** The minimum date that can be selected */
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  /** The maximum date that can be selected */
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  /** An array containing date objects that represent unavailable dates. */
  unavailableDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  /** A four digit number (e.g., 2016) representing the year that should be rendered. */
  year: PropTypes.number,
  /** A callback that's triggered when the `Cancel` button is clicked. */
  onCancel: PropTypes.func,
  /** A callback that's triggered when the `Ok` button is clicked. This callback receives the same parameter as the `onDateChange` callback. */
  onSubmit: PropTypes.func,
  /** onKeyDown callback. keyDown event in arg */
  onKeyDown: PropTypes.func,
  /** onMouseEnter callback. */
  onMouseEnter: PropTypes.func,
  /** onMouseLeave callback. */
  onMouseLeave: PropTypes.func,
  /** onDateChange callback from clicking calendar day. ({date, week, value}, event) */
  onDateChange: PropTypes.func,
  /** Calendar day Id */
  id: PropTypes.string,
  /** Select a range of dates */
  selectRange: PropTypes.bool,
  /** Select a week of dates */
  selectWeek: PropTypes.bool,
  /** Add utility props for styling */
  utils: PropTypes.object
};
var calendarDefaultProps = {
  date: '',
  id: '',
  hasFooter: false,
  hasHeader: true,
  month: new Date().getMonth(),
  range: null,
  minDate: null,
  maxDate: null,
  unavailableDates: [],
  year: new Date().getFullYear(),
  onCancel: function onCancel() {},
  onSubmit: function onSubmit() {},
  onKeyDown: function onKeyDown() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onDateChange: function onDateChange() {},
  selectRange: false,
  selectWeek: false,
  utils: {}
};

/**
 * Utility function that returns a boolean
 * determining if the selected date is active.
 */
function isDayActive(selectedDate, dateVal, isDisabled) {
  // if we're disabled, then we can't be active.
  if (isDisabled) {
    return false;
  }
  return [].concat(selectedDate).find(function (date) {
    return date instanceof Date && DateUtils.datesMatch(date, dateVal);
  });
}

/**
 * Utility function that returns a boolean
 * determining if date is between 2 selected dates.
 */
function isDayInRange(selectedDate, dateVal) {
  if (!Array.isArray(selectedDate)) {
    return false;
  }
  if (selectedDate.length < 2) {
    return false;
  }
  return DateUtils.dateIsInRange(dateVal, selectedDate) && !DateUtils.datesMatch(selectedDate[0], selectedDate[1]);
}

/**
 * Utility function that returns a boolean
 * that determines is the provided day should be disabled
 * (on the calendar).
 */
function isDayDisabled(dayVal, missingDates, dateRange) {
  // if the day falls in a different month
  var newDate = new Date(dayVal.date);
  if (missingDates instanceof Array && DateUtils.datesContain(missingDates, newDate)) {
    return true;
  }
  return dateRange instanceof Array && !DateUtils.dateIsInRange(newDate, dateRange);
}
function isFocusable(calendar, targetDay, missingDates) {
  return (
    // day should not be 'unavailable'
    !missingDates.find(function (d) {
      return DateUtils.datesMatch(d, calendar.days[targetDay]);
    }) &&
    // day should be in the same month of current calendar
    calendar.days.find(function (_ref) {
      var day = _ref.day,
        month = _ref.month;
      return day === targetDay && month === calendar.month;
    })
  );
}
var focusAdjacentDay = function focusAdjacentDay(direction, calendarId, calendar, currentDay, missingDates) {
  var targetDay = currentDay;
  switch (direction) {
    case 'right':
      targetDay += 1;
      break;
    case 'left':
      targetDay -= 1;
      break;
    case 'down':
      targetDay += 7;
      break;
    case 'up':
      targetDay -= 7;
      break;
  }
  if (!isFocusable(calendar, targetDay, missingDates)) {
    return;
  }
  var _calendar$weeks$reduc = calendar.weeks.reduce(function (curr, days, index) {
      var found = days.find(function (_ref2) {
        var day = _ref2.day,
          month = _ref2.month;
        return day === targetDay && month === calendar.month;
      });
      return found ? [index, found.dayOfWeek] : curr;
    }, [null, null]),
    _calendar$weeks$reduc2 = _slicedToArray(_calendar$weeks$reduc, 2),
    targetWeekIndex = _calendar$weeks$reduc2[0],
    targetDayIndex = _calendar$weeks$reduc2[1];
  try {
    document.getElementById("".concat(calendarId, "-day-").concat(targetWeekIndex, "-").concat(targetDayIndex)).focus();
  } catch (e) {
    // could not focus target button
  }
};
var switchFocus = function switchFocus(key, calendarId, monthVal, currentDay, event, unavailableDates) {
  switch (key) {
    case 'ArrowRight':
    case 39:
      focusAdjacentDay('right', calendarId, monthVal, currentDay, unavailableDates);
      break;
    case 'ArrowLeft':
    case 37:
      focusAdjacentDay('left', calendarId, monthVal, currentDay, unavailableDates);
      break;
    case 'ArrowDown':
    case 40:
      event.preventDefault();
      focusAdjacentDay('down', calendarId, monthVal, currentDay, unavailableDates);
      break;
    case 'ArrowUp':
    case 38:
      event.preventDefault();
      focusAdjacentDay('up', calendarId, monthVal, currentDay, unavailableDates);
      break;
  }
};
var setCalendarValues = function setCalendarValues(_ref3) {
  var _month = _ref3._month,
    _year = _ref3._year,
    _date = _ref3._date,
    month = _ref3.month,
    year = _ref3.year,
    date = _ref3.date,
    setDate = _ref3.setDate,
    setMonth = _ref3.setMonth,
    setYear = _ref3.setYear;
  if ((month || month === 0) && month !== _month) {
    setMonth(month);
  }
  if (year && year !== _year) {
    setYear(year);
  }
  if (date && date !== _date) {
    setDate(date);
  }
};
var processMonth = function processMonth(month, currentDate, unavailableDates, availableRange) {
  return _objectSpread(_objectSpread({}, month), {}, {
    // map weeks
    weeks: month.weeks.map(function (week, weekOfMonth) {
      // week is considered in range if it contains and active date
      var isWeekInRange = false;
      var isWeekRangeStart = false;
      var isWeekRangeEnd = false;
      var days = week.reduce(function (curr, day) {
        var isDisabled = isDayDisabled(day, unavailableDates, availableRange);
        var isActive = isDayActive(currentDate, new Date(day.date), isDisabled);
        var isInRange = isDayInRange(currentDate, new Date(day.date));
        if (isActive || isInRange) {
          isWeekInRange = true;
        }
        var isRangeStart, isRangeEnd;
        if (Array.isArray(currentDate)) {
          isRangeStart = DateUtils.datesMatch(day.date, currentDate[0]);
          isRangeEnd = DateUtils.datesMatch(day.date, currentDate[1]);
          // if only 1 date, 'from' date is also 'to' date
          if (currentDate.length == 1 && isRangeStart) {
            isRangeEnd = true;
          }
        }
        isWeekRangeStart = isRangeStart ? true : isWeekRangeStart;
        isWeekRangeEnd = isRangeEnd ? true : isWeekRangeEnd;
        return [].concat(_toConsumableArray(curr), [_objectSpread(_objectSpread({}, day), {}, {
          isActive: isActive,
          isDisabled: isDisabled,
          isInRange: isInRange,
          isRangeStart: isRangeStart,
          isRangeEnd: isRangeEnd
        })]);
      }, []);
      return {
        days: days,
        weekOfMonth: weekOfMonth,
        isWeekInRange: isWeekInRange,
        isWeekRangeStart: isWeekRangeStart,
        isWeekRangeEnd: isWeekRangeEnd
      };
    })
  });
};
var calendarEventHandler = function calendarEventHandler(day, isSelectRange, isSelectWeek, currentDate, currentSelectionIndex, callback) {
  // get date clicked / hovered
  var targetDate = new Date(day.date);
  if (!isSelectRange && !isSelectWeek) {
    // return if not selecting a range of dates
    callback({
      date: targetDate
    });
    return;
  }
  if (isSelectWeek) {
    // return week with start / end dates
    var startOfWeek = new Date(targetDate);
    startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
    var endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);
    callback({
      date: targetDate,
      week: [startOfWeek, endOfWeek]
    });
    return;
  }
  var selectedDateRange = [].concat(currentDate || []);
  var nextSelectionIndex;
  if (selectedDateRange.length < 2) {
    // check if date should be 'from' or 'to'
    if (targetDate < new Date(selectedDateRange[0])) {
      selectedDateRange.unshift(targetDate);
    } else {
      selectedDateRange.push(targetDate);
    }
    callback({
      date: selectedDateRange
    });
    return;
  }
  if (targetDate > selectedDateRange[1]) {
    selectedDateRange[1] = targetDate;
    nextSelectionIndex = 0;
  } else if (targetDate < selectedDateRange[0]) {
    selectedDateRange[0] = targetDate;
    nextSelectionIndex = 1;
  } else {
    selectedDateRange[currentSelectionIndex] = targetDate;
    nextSelectionIndex = currentSelectionIndex ? 0 : 1;
  }
  callback({
    date: selectedDateRange,
    nextSelectionIndex: nextSelectionIndex
  });
};
var getWeekRowProps = function getWeekRowProps(week, date) {
  var isWeekRangeEnd = week.isWeekRangeEnd,
    isMonthAfterRangeEnd = week.isMonthAfterRangeEnd;
  // check if range ends before current month (required for styling)
  if (week.weekOfMonth === 0 && Array.isArray(date) && !week.isWeekRangeEnd) {
    isWeekRangeEnd = date.slice(-1)[0] < new Date(week.days[0].date);
    isMonthAfterRangeEnd = isWeekRangeEnd;
  }
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, week.isWeekInRange && {
    'data-selected-week': true
  }), week.isWeekRangeStart && {
    'data-week-range-start': true
  }), isWeekRangeEnd && {
    'data-week-range-end': true
  }), isMonthAfterRangeEnd && {
    'data-month-range-end': true
  }), {}, {
    key: "week-".concat(week.weekOfMonth)
  });
};
var getConditionalProps = function getConditionalProps(day, month) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, day.isActive && {
    'data-selected-day': true
  }), day.isDisabled && {
    'data-disabled-day': true
  }), day.isRangeStart && {
    'data-range-start': true
  }), day.isRangeEnd && {
    'data-range-end': true
  }), day.isInRange && {
    'data-in-range': true
  }), day.isMonthStart && {
    'data-month-start': true
  }), day.isMonthEnd && {
    'data-month-end': true
  }), day.month < month && {
    'data-previous-month': true
  }), day.month > month && {
    'data-next-month': true
  });
};
var getDayCellProps = function getDayCellProps(day, week, month) {
  // check if day is the first day of the month (required for styling)
  var isMonthStart = day.day === 1;
  // check if day is the last day of the month (required for styling)
  var isMonthEnd = false;
  if (day.day > 27) {
    // get the last day of month
    isMonthEnd = day.day === new Date(day.year, day.month + 1, 0).getDate();
  }
  return _objectSpread(_objectSpread({}, getConditionalProps(_objectSpread(_objectSpread({}, day), {}, {
    isMonthStart: isMonthStart,
    isMonthEnd: isMonthEnd
  }), month)), {}, {
    key: "week-".concat(week.weekOfMonth, "-day-").concat(day.dayOfWeek)
  });
};
var getCalendarDate = function getCalendarDate(month, year, setMonth, setYear) {
  setMonth(month);
  setYear(year);
};
var getMonthYear = function getMonthYear(month, year, now) {
  return {
    useMonth: isNaN(month) ? now.getMonth() : month,
    useYear: isNaN(year) ? now.getFullYear() : year
  };
};

/**
 * React Calendar that renders a calendar month
 * and provides a callback that is triggered when
 * the calendar date changes. The Calendar will optionally
 * render a footer containing a cancel and ok button.
 */

/**
 * @ignore @description
 * ## Calendar Component
 * Use the Calendar component to select dates, months and provide interaction callbacks.
 *
 * @ignore @see Mesh: [Calendar Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/containers-calendar--default)
 *
 * @ignore @example
 * ```jsx
 * import { Calendar } from 'mesh-component-library';
 *
 * <Calendar {...props}/>
 * ```
 */

var Calendar = function Calendar(props) {
  var id = props.id,
    date = props.date,
    month = props.month,
    year = props.year,
    hasFooter = props.hasFooter,
    hasHeader = props.hasHeader,
    onCancel = props.onCancel,
    range = props.range,
    unavailableDates = props.unavailableDates,
    onKeyDown = props.onKeyDown,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    onSubmit = props.onSubmit,
    onDateChange = props.onDateChange,
    selectRange = props.selectRange,
    selectWeek = props.selectWeek,
    minDate = props.minDate,
    maxDate = props.maxDate,
    other = _objectWithoutProperties(props, _excluded);
  var CalendarRef = useRef();
  var _useState = useState(date),
    _useState2 = _slicedToArray(_useState, 2),
    _date = _useState2[0],
    setDate = _useState2[1];
  var calendarId = id || generateID('calendar_');
  var _useState3 = useState(month === null ? '' : month),
    _useState4 = _slicedToArray(_useState3, 2),
    _month = _useState4[0],
    setMonth = _useState4[1];
  var _useState5 = useState(year === null ? '' : year),
    _useState6 = _slicedToArray(_useState5, 2),
    _year = _useState6[0],
    setYear = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isValidSelection = _useState8[0],
    setIsValidSelection = _useState8[1];
  var now = new Date();
  // whether the next click is the 'from' date or the 'to' date.
  var nextSelectionIndex = useRef(0);
  var calendarMonth = CalendarUtils.buildPaddedCalendarMonth(_month, _year);
  var _processMonth = processMonth(calendarMonth, _date, unavailableDates, range || [minDate, maxDate]),
    daysOfTheWeek = _processMonth.daysOfTheWeek,
    weeks = _processMonth.weeks;
  var onClickHandler = function onClickHandler(day, event) {
    var callback = function callback(resp) {
      onDateChange(_objectSpread({
        date: resp.date
      }, resp.week && {
        week: resp.week
      }), event);
      if (typeof resp.nextSelectionIndex !== 'undefined') {
        nextSelectionIndex.current = resp.nextSelectionIndex;
      }
      setDate(resp.date);
    };
    calendarEventHandler(day, selectRange, selectWeek, _date, nextSelectionIndex.current, callback);
  };
  var onMouseEnterHandler = function onMouseEnterHandler(day) {
    var callback = function callback(resp) {
      onMouseEnter(_objectSpread({
        date: resp.date
      }, resp.week && {
        week: resp.week
      }));
    };
    // enable range highlighting on valid dates only
    setIsValidSelection(true);
    calendarEventHandler(day, selectRange, selectWeek, _date, nextSelectionIndex.current, callback);
    return true;
  };
  var onMouseLeaveHandler = function onMouseLeaveHandler(day) {
    onMouseLeave(day);
    // enable range highlighting on valid dates only
    setIsValidSelection(false);
  };
  var onKeydownDay = function onKeydownDay(event, week, day) {
    var key = event.key || event.keyCode;
    var monthVal = CalendarUtils.buildPaddedCalendarMonth(day.month, day.year);
    var currentDay = day.day;
    switchFocus(key, calendarId, monthVal, currentDay, event, unavailableDates);
    onKeyDown(event);
  };

  /**
   * Trigger the onCancel callback
   */
  var onCancelClick = function onCancelClick() {
    var selectedDate = new Date(date);
    setDate(selectedDate);
    onCancel();
  };

  /**
   * Trigger the onSubmit callback
   */
  var onSubmitClick = function onSubmitClick() {
    onSubmit({
      date: _date
    });
  };
  useEffect(function () {
    setCalendarValues({
      _month: _month,
      _year: _year,
      _date: _date,
      month: month,
      year: year,
      date: date,
      setDate: setDate,
      setMonth: setMonth,
      setYear: setYear
    });
  }, [month, year, date]);

  /** Create months list for dropdown */
  var months = CONSTANTS.MONTHS.map(function (m, index) {
    return {
      text: m[0],
      value: index
    };
  });
  var useRange = range || [DateUtils.toDate(minDate), DateUtils.toDate(maxDate)];
  var _getMonthYear = getMonthYear(month, year, now),
    useMonth = _getMonthYear.useMonth,
    useYear = _getMonthYear.useYear;

  /** Create years list for dropdown */
  var now_year = now.getFullYear();
  var year_from = useRange[0] ? useRange[0].getFullYear() : Math.min(now_year - 100, useYear);
  /** Ensure `year_to` is at least 1 year after `year_from` */
  var year_to = useRange[1] ? useRange[1].getFullYear() : Math.max(now_year, useYear, year_from) + 1;
  var years = Array(year_to - year_from + 1).fill().map(function (y, index) {
    return {
      text: year_from + index,
      value: year_from + index
    };
  });
  var contextValue = React.useContext(DatePickerContext);
  return /*#__PURE__*/React.createElement(StyledCalendar, _extends({}, other, {
    ref: CalendarRef
  }), /*#__PURE__*/React.createElement(StyledCalendarBody, null, /*#__PURE__*/React.createElement(StyledCalendarTable, {
    "aria-label": "".concat(calendarMonth.fullName, " ").concat(calendarMonth.year),
    isValidSelection: isValidSelection,
    selectedDate: _date,
    selectRange: selectRange,
    selectWeek: selectWeek
  }, /*#__PURE__*/React.createElement("thead", null, hasHeader && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    colSpan: "7"
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Column, {
    col: 7
  }, /*#__PURE__*/React.createElement(Dropdown, {
    options: months,
    onChange: function onChange(e) {
      getCalendarDate(parseInt(e.target.value), _year, setMonth, setYear);
    },
    value: useMonth.toString(),
    "aria-label": "Month",
    isBlock: true,
    autoFocus: !!contextValue
  })), /*#__PURE__*/React.createElement(Grid.Column, {
    col: 5
  }, /*#__PURE__*/React.createElement(Dropdown, {
    options: years,
    onChange: function onChange(e) {
      getCalendarDate(_month, parseInt(e.target.value), setMonth, setYear);
    },
    value: useYear.toString(),
    "aria-label": "Year"
  }))))), /*#__PURE__*/React.createElement("tr", null, daysOfTheWeek.map(function (dayNames, i) {
    // grab the single letter
    var name = dayNames[1].substring(0, 2).toLowerCase();
    var dayWeek = i;
    return /*#__PURE__*/React.createElement("th", {
      key: "".concat(name, "-").concat(dayWeek),
      "aria-label": dayNames[0]
    }, /*#__PURE__*/React.createElement(StyledCalendarTableHeaderDay, null, /*#__PURE__*/React.createElement(Type, {
      element: "span",
      size: "sm",
      utils: {
        textColor: colors.cool_gray_900
      }
    }, name)));
  }))), /*#__PURE__*/React.createElement("tbody", null, weeks.map(function (week, weekIndex) {
    return /*#__PURE__*/React.createElement("tr", getWeekRowProps(week, _date), week.days.map(function (day, dayIndex) {
      return /*#__PURE__*/React.createElement("td", getDayCellProps(day, week, _month), /*#__PURE__*/React.createElement("div", null, day.month === calendarMonth.month && /*#__PURE__*/React.createElement(CalendarDay, {
        "aria-label": "".concat(day.day, " ").concat(calendarMonth.fullName, " ").concat(calendarMonth.year),
        id: "".concat(calendarId, "-day-").concat(weekIndex, "-").concat(dayIndex),
        onKeydownDay: onKeydownDay,
        active: day.isActive,
        day: day,
        disabled: day.isDisabled,
        date: _date,
        week: weekIndex,
        onClick: onClickHandler,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler
      })));
    }));
  })))), hasFooter ? /*#__PURE__*/React.createElement(StyledCalendarFooter, null, /*#__PURE__*/React.createElement(StyledCalendarButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    isPrimary: false,
    variant: "information",
    disabled: !DateUtils.isDate(_date),
    onClick: onSubmitClick
  }, "ok"), /*#__PURE__*/React.createElement(Button, {
    isPrimary: false,
    variant: "muted",
    onClick: onCancelClick
  }, "cancel"))) : '');
};
Calendar.propTypes = calendarPropTypes;
Calendar.defaultProps = calendarDefaultProps;
export default Calendar;